import Take3D from "../../../models/Take3D";
import {
  getTakeEndState,
  isHeldByAttachment,
} from "../../../helpers/TakeEndState";

export class TrainingSliceStrategy3DHelper {
  /**
   * A new take starts where the previous one ends: with the attachments its
   * interactions and sequence leave behind. A prop an actor now holds is no
   * longer placed on its position.
   */
  static updateActorProp(previousTake: Take3D, newTake: Take3D): Take3D {
    const { attachments } = getTakeEndState(previousTake);

    return {
      ...newTake,
      attachments,
      props: newTake.props.filter(
        (prop) => !isHeldByAttachment(attachments, prop.instanceId)
      ),
    };
  }
}
